export const isTokenExpired = (token) => {
  try {
    if (!token) {
      return true;
    }
    const decoded = JSON.parse(atob(token.split(".")[1]));
    return Date.now() >= decoded.exp * 1000;
  } catch (error) {
    return true;
  }
};

export const getValidSession = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  if (!token || isTokenExpired(token)) return null;
  return { token, role };
};
